// extracted by mini-css-extract-plugin
module.exports = {"container":"_2VRHatatmurSFqQRiKurLy","hidden":"_2m0kr2Oi7o5xNWCx5-Msxq"};